// tslint:disable:no-console
// tslint:disable no-unused-expression
import { accountActionsFeature } from '@central-products/account-actions';
import { WelcomeMessagesFlow } from '@central-products/welcome-messages-flow';
import MessageBusTransport from '@central-products/message-transport-bus';

export interface BootstrapperConfig {
  ignoreAccountActions: boolean;
}

export default async ({ ignoreAccountActions }: BootstrapperConfig = { ignoreAccountActions: false }) => {
  const transport = MessageBusTransport.getInstance();

  tryTo(
    () => {
      new WelcomeMessagesFlow({ transport });
    },
    (err) => console.error('Warning: Failed to initiate WelcomeMessagesFlow. Might be already initiated.', err),
  );

  if (!ignoreAccountActions) {
    await tryTo(
      () => {
        return accountActionsFeature.init({ transport });
      },
      (err) => console.error('Warning: Failed to initiate AccountActions. Might be already initiated.', err),
    );
  }

  return Promise.resolve(transport);
};

function tryTo(cb: () => void, onFail: (err: Error) => void) {
  try {
    return cb();
  } catch (err) {
    onFail(err);
  }
}
